<template>
  <b-form @submit="onSubmit" :class="'h-100 d-flex'">
    <b-form-row class="w-100 mx-0">
      <b-col cols="12" sm="4" class="px-0">
        <overlay-scrollbars :options="{ scrollbars: { autoHide: false }, overflowBehavior: { y: 'scroll', x: 'hidden' }, className : 'os-theme-dark os-theme-gekko' }">
          <div class="modal-form-legend">
            <legend v-translate>Details</legend>
          </div>
          <b-form-row>
            <b-col cols="12" lg="12">
              <b-form-group id="input-group-1" label-class="gk-label-margin gk-modal-label"
                            :label="$gettext('Brand Name*')" label-for="input-1">
                <b-form-input data-analytics-click id="input-2" v-model="brand.name" required
                              :placeholder="$gettext('Planet Express')" @input="brandNameChanged"></b-form-input>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col cols="12" lg="12">
              <b-form-group id="input-group-2" label-class="gk-label-margin gk-modal-label"
                            :label="$gettext('Brand Email*')" label-for="input-2">
                <b-form-input data-analytics-click id="input-2" v-model="brand.brand_email" type="email" required
                              :placeholder="$gettext('goodnews@momcorp.com')"></b-form-input>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col cols="12" lg="12">
              <b-form-group id="input-group-3" label-class="gk-label-margin gk-modal-label"
                            :label="$gettext('Brand Address*')" label-for="input-3">
                <b-form-input data-analytics-click id="input-2" v-model="brand.brand_address" required
                              :placeholder="$gettext('West 57th Street')"></b-form-input>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col cols="12" lg="6">
              <b-form-group id="input-group-4" label-class="gk-label-margin gk-modal-label"
                            :label="$gettext('Brand Postal Code*')" label-for="input-4">
                <b-form-input data-analytics-click id="input-2" v-model="brand.brand_postal_code" required
                              :placeholder="$gettext('3000AD')"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="6">
              <b-form-group id="input-group-5" label-class="gk-label-margin gk-modal-label"
                            :label="$gettext('Brand City*')" label-for="input-5">
                <b-form-input data-analytics-click id="input-2" v-model="brand.brand_city" required
                              :placeholder="$gettext('New York')"></b-form-input>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col cols="12" lg="12">
              <b-form-group id="input-group-6" label-class="gk-label-margin gk-modal-label"
                            :label="$gettext('Brand Country*')" label-for="input-6">
                <b-form-select id="input-6" v-model="brand.brand_country" :options="countries" required></b-form-select>
              </b-form-group>
            </b-col>
          </b-form-row>

          <div class="modal-form-legend">
            <legend v-translate>Custom Fields</legend>
          </div>
          <b-form-row>
            <b-col cols="12" lg="6">
              <b-form-group id="input-group-7" label-class="gk-label-margin gk-modal-label" label-for="input-7">
                <b-form-input data-analytics-click id="input-2" v-model="brand.label_0"
                              :placeholder="$gettext('Phone Number')"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="6">
              <b-form-group id="input-group-8" label-class="gk-label-margin gk-modal-label" label-for="input-8">
                <b-form-input data-analytics-click id="input-2" v-model="brand.field_0"
                              :placeholder="$gettext('field value')"></b-form-input>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col cols="12" lg="6">
              <b-form-group id="input-group-9" label-class="gk-label-margin gk-modal-label" label-for="input-9">
                <b-form-input data-analytics-click id="input-2" v-model="brand.label_1"
                              :placeholder="$gettext('Website')"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="6">
              <b-form-group id="input-group-10" label-class="gk-label-margin gk-modal-label" label-for="input-10">
                <b-form-input data-analytics-click id="input-2" v-model="brand.field_1"
                              :placeholder="$gettext('field value')"></b-form-input>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col cols="12" lg="6">
              <b-form-group id="input-group-11" label-class="gk-label-margin gk-modal-label" label-for="input-11">
                <b-form-input data-analytics-click id="input-2" v-model="brand.label_2"
                              :placeholder="$gettext('KVK')"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="6">
              <b-form-group id="input-group-12" label-class="gk-label-margin gk-modal-label" label-for="input-12">
                <b-form-input data-analytics-click id="input-2" v-model="brand.field_2"
                              :placeholder="$gettext('field value')"></b-form-input>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col cols="12" lg="6">
              <b-form-group id="input-group-13" label-class="gk-label-margin gk-modal-label" label-for="input-13">
                <b-form-input data-analytics-click id="input-2" v-model="brand.label_3"
                              :placeholder="$gettext('BTW')"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="6">
              <b-form-group id="input-group-14" label-class="gk-label-margin gk-modal-label" label-for="input-14">
                <b-form-input data-analytics-click id="input-2" v-model="brand.field_3"
                              :placeholder="$gettext('field value')"></b-form-input>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col cols="12" lg="6">
              <b-form-group id="input-group-15" label-class="gk-label-margin gk-modal-label" label-for="input-15">
                <b-form-input data-analytics-click id="input-2" v-model="brand.label_4"
                              :placeholder="$gettext('Bank Account Number')"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="6">
              <b-form-group id="input-group-16" label-class="gk-label-margin gk-modal-label" label-for="input-16">
                <b-form-input data-analytics-click id="input-2" v-model="brand.field_4"
                              :placeholder="$gettext('field value')"></b-form-input>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col cols="12" lg="6">
              <b-form-group id="input-group-17" label-class="gk-label-margin gk-modal-label" label-for="input-17">
                <b-form-input data-analytics-click id="input-2" v-model="brand.label_5"
                              :placeholder="$gettext('Swift Number')"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="6">
              <b-form-group id="input-group-18" label-class="gk-label-margin gk-modal-label" label-for="input-18">
                <b-form-input data-analytics-click id="input-2" v-model="brand.field_5"
                              :placeholder="$gettext('field value')"></b-form-input>
              </b-form-group>
            </b-col>
          </b-form-row>
        </overlay-scrollbars>
      </b-col>
      <b-col cols="12" sm="8" class="modal-dropzone-actions pr-0">
        <div class="modal-dropzone-actions--wrap">
          <div class="modal-dropzone-wrapper">
            <VueDropzone :preloaded_file="imageSrc" :allowed-files="'all'" :onlyChange="true" @change="fileChanged"></VueDropzone>
          </div>
        </div>
        <b-row class="bottom-actions">
          <b-col class="bottom-actions-btn-wrap">
            <GekkoButton
                :text="$gettext('Save Brand')"
                icon="fa-regular fa-floppy-disk"
                type="submit"
                :disabled="isSaving"
                class="float-right"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-form-row>
  </b-form>
</template>
<script>
import { mapGetters } from "vuex"

import BrandService from "@/store/services/brand.service"
import CompanyService from "@/store/services/company.service"

import VueDropzone from "@/components/VueDropzone"
import GekkoButton from "@/components/GekkoButton"

export default {
  name: "BrandCreateEdit",
  props: {
  },
  components: {
    GekkoButton, VueDropzone,
  },
  data() {
    return {
      countries: [],
      isSaving: false,
      imageSrc: null,
      brand: {
        id: null,
        brand_logo: null,
        name: "",
        brand_email: "",
        brand_address: "",
        brand_postal_code: "",
        brand_city: "",
        brand_country: "",

        label_0: "",
        label_1: "",
        label_2: "",
        label_3: "",
        label_4: "",
        label_5: "",
        field_0: "",
        field_1: "",
        field_2: "",
        field_3: "",
        field_4: "",
        field_5: "",
        company_profile: window.company_id,
        created_by: window.user_id,
      },
    }
  },
  computed: {
    ...mapGetters({
      selectedBrandName: 'brands/getSelectedBrandName',
      selectedBrandId: 'brands/getSelectedBrandId',
    }),
    isEdit() {
      return this.selectedBrandId > 0;
    },
  },
  created(){
    CompanyService.getCountries().then((response) => {
      this.countries = response.data;
    })
    if (this.selectedBrandId > 0) {    //EDIT
      this.retrieveBrand()
    }
  },
  methods: {
    retrieveBrand () {
      BrandService.retrieve(this.selectedBrandId).then((response)=>{
        this.brand = response.data;
        if (this.brand.brand_logo) {
          this.imageSrc = this.brand.brand_logo;
          delete this.brand.brand_logo
        } else {
          this.imageSrc = null;
        }
      })
    },
    onSubmit(e) {
      this.isSaving = true;
      e.preventDefault();
      this.saveBrand()
    },
    saveBrand () {
      for (var propName in this.brand) {
        if (this.brand[propName] === null || this.brand[propName] === undefined) {
          delete this.brand[propName];
        }
      }
      if (this.isEdit) {    //EDIT
        BrandService.update(this.brand.id, this.brand).then( (response) => {
          this.brand.brand_logo = response.data.brand_logo;
          this.$store.commit('setAlert', {title: this.$gettext("Brand Updated"), text:this.$gettext("Successfully edited the brand"), variant:"success",duration:4});
          this.$emit('edited', response.data);
        }).catch( (response) => {
          this.saveError(response)
        })
      } else {
        BrandService.create(this.brand).then( (response) => {
          this.$store.commit('setAlert', {title: this.$gettext("Brand Created"), text:this.$gettext("Successfully created the brand"), variant:"success",duration:4});
          this.$emit('created', response.data);
        }).catch( (response) => {
          this.saveError(response)
        })
      }
    },
    saveError (response) {
      this.isSaving = false;
      this.$store.commit('setAlert', {title: this.$gettext("Error"), text:this.$gettext("Something went wrong, brand is not saved."), variant:"danger",duration:4});
    },
    fileChanged(file){
      this.brand.brand_logo = file;
    },
    brandNameChanged(value){
      this.$store.commit('brands/SET_SELECTED_BRAND_NAME', value);
    }
  }
};
</script>
<style lang="scss" scoped>
.modal-dropzone-actions {
  .modal-dropzone-actions--wrap {
    margin-bottom: 20px;
    .modal-dropzone-wrapper {
      flex: 1;
      height: calc(100% - 50px) !important; // smartScan height + margin top
      margin-top: 10px;
    }
  }
}
.modal-content {
  height: 100%;
  overflow: hidden;
  .contact-tabs {
    height: 100%;
    .tab-content {
      height: 100%;
      .os-host-overflow-y {
        padding-right: 1rem;
      }
    }
  }
}
.bottom-actions {
  margin-top: 20px;
  .bottom-actions-btn-wrap {
    display: flex;
    width: 100%;
    justify-content: flex-end;
    .nav-btns {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      flex: 1;
      .nav-disabled { opacity: 0.4; }
      .nav-separator { opacity: 0.5; }
    }
  }
}
.nav-tooltip { font-size: 12px; line-height: 1.2; }
</style>

<style lang="scss">
.os-theme-dark.os-theme-gekko > .os-scrollbar > .os-scrollbar-track > .os-scrollbar-handle {
  background: rgba(0, 0, 0, 0.2);
}
</style>